import React from 'react'

import { TableCell } from '@material-ui/core'
import { ReactComponent as ArrowDown } from 'shared/assets/arrow-down.svg'

import { StudentsTableRow } from 'store/services/Classes/types'

import { SortingOrder } from '../StudentsTable'
import styles from '../StudentsTable.module.scss'

interface SortableColumnHeaderProps {
  name: keyof StudentsTableRow
  sortKey: keyof StudentsTableRow
  order: SortingOrder
  label: string
  onClick: (key: keyof StudentsTableRow) => void
}

const SortableColumnHeader = ({ name, order, sortKey, label, onClick }: SortableColumnHeaderProps) => {
  return (
    <TableCell>
      <span onClick={() => onClick(name)} className={styles.headerCell}>
        {label}
        {sortKey === name && <ArrowDown style={order === 'dsc' ? undefined : { transform: `rotate(180deg)` }} />}
      </span>
    </TableCell>
  )
}

export default SortableColumnHeader
